module.exports = __webpack_public_path__ + "img/hakurei tea party.267fd68f.png";